
import { defineComponent } from "vue";
import NavBar from "@/components/NavBar.vue";

// @Component({
//   components: {
//     NavBar,
//   },
// })
// export default class App extends Vue {}

export default defineComponent({
  components: {
    NavBar,
  },
});
